import React from 'react'

// components

import CardBarTodayStoreSales from 'components/Cards/CardBarTodayStoreSales'
import CardBarMonthStoreSales from 'components/Cards/CardBarMonthStoreSales'

export default function Dashboard() {
    return (
        <>
            <div className="flex flex-wrap">
                <div className="w-full xl:w-12/12 px-4">
                    <CardBarTodayStoreSales />
                </div>
                <div className="w-full xl:w-12/12 px-4">
                    <CardBarMonthStoreSales />
                </div>
                {/* <div className="w-full xl:w-12/12 mb-12 xl:mb-0 px-4">
                    <CardLineChart />
                </div> */}
            </div>
        </>
    )
}
